import React from "react";

function TablePagination({
  pageOptions,
  pageIndex,
  pageSize,
  pageCount,
  canNextPage,
  canPreviousPage,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
}) {
  return (
    <div className="table-pagination">
      <button className="btn btn-primary btn-sm" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
        {"<<"}
      </button>{" "}
      <button className="btn btn-primary btn-sm" onClick={() => previousPage()} disabled={!canPreviousPage}>
        {"<"}
      </button>{" "}
      <button className="btn btn-primary btn-sm" className="btn btn-primary btn-sm" onClick={() => nextPage()} disabled={!canNextPage}>
        {">"}
      </button>{" "}
      <button className="btn btn-primary btn-sm" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
        {">>"}
      </button>
      <span>
        {" "}
        Page{" "}
        <strong>
          {pageIndex + 1} of {pageOptions.length}
        </strong>{" "}
      </span>
    </div>
  );
}

export default TablePagination;
